export const wordThree = [
  {
    id: 1,
    text: "Romance",
    response: "Pride and Prejudice is a famous romantic novel.",
  },
  {
    id: 2,
    text: "Heritage",
    response: "Heritage sites reflect history.",
  },
  {
    id: 3,
    text: "Hard",
    response: "Diamond is the hardest substance on earth.",
  },
  {
    id: 4,
    text: "Communicate",
    response: "A good leader communicates effectively.",
  },
  {
    id: 5,
    text: "Trouble",
    response: "Chasing dreams is worth the trouble.",
  },
  {
    id: 6,
    text: "Hostile",
    response: "Indian forces defend Siachen despite its hostile conditions.",
  },
  {
    id: 7,
    text: "Honest",
    response: "Friendship is all about loyalty and honesty.",
  },
  {
    id: 8,
    text: "Event",
    response: "Every event in life has a lesson to teach.",
  },
  {
    id: 9,
    text: "Curious",
    response: "Curiosity leads to learning.",
  },
  {
    id: 10,
    text: "Mother",
    response: "Mother India was the first Indian movie nominated for an Oscar.",
  },
  {
    id: 11,
    text: "Confusion",
    response: "Lack of knowledge leads to confusion.",
  },
  {
    id: 12,
    text: "Relax",
    response: "A relaxed mind is more productive.",
  },
  {
    id: 13,
    text: "Survive",
    response: "Many businesses struggle to survive due to Covid.",
  },
  {
    id: 14,
    text: "Hard work",
    response: "Determination and hard work makes dream reality.",
  },
  {
    id: 15,
    text: "Accurate",
    response: "Practice increases accuracy.",
  },
  {
    id: 16,
    text: "Fail",
    response: "Take failures as lessons.",
  },
  {
    id: 17,
    text: "Loose",
    response: "Always be aware of enemy loose ends.",
  },
  {
    id: 18,
    text: "Hijack",
    response: "Judicial control is hijacked in non-democratic countries.",
  },
  {
    id: 19,
    text: "Enemy",
    response: "Patriarchy is the enemy of progress.",
  },
  {
    id: 20,
    text: "Pity",
    response: "Don't be self-pitying, rather improve your condition.",
  },
  {
    id: 21,
    text: "sad",
    response: "Talking to friends helps lift a sad mood.",
  },
  {
    id: 22,
    text: "Measure",
    response: "Kelvin is the standard temperature measurement unit.",
  },
  {
    id: 23,
    text: "Initiative",
    response: "This country needs anti-poverty initiatives.",
  },
  {
    id: 24,
    text: "Rural",
    response: "Rural education system must be improved.",
  },
  {
    id: 25,
    text: "Literacy",
    response: "Literacy gives hope.",
  },
  {
    id: 26,
    text: "Culture",
    response: "Indian culture is very diverse.",
  },
  {
    id: 27,
    text: "Mourn",
    response: "The country mourns its martyrs.",
  },
  {
    id: 28,
    text: "Shame",
    response: "There is no shame in admitting our mistakes.",
  },
  {
    id: 29,
    text: "School",
    response: "The Commando school is located in Belgaum.",
  },
  {
    id: 30,
    text: "Picture",
    response: "Pictures leave a lasting impression on the brain than words do.",
  },
  {
    id: 31,
    text: "Fire",
    response: "Control of fire is one of the early inventions by humankind.",
  },
  {
    id: 32,
    text: "Plan",
    response: "Plan ahead to reduce stress.",
  },
  {
    id: 33,
    text: "Mistake",
    response: "Ignorance leads to stupid mistakes.",
  },
  {
    id: 34,
    text: "Modern",
    response: "Social media are a modern form of communication.",
  },
  {
    id: 35,
    text: "Learn",
    response: "E-learning is the future of education.",
  },
  {
    id: 36,
    text: "Aid",
    response:
      "India has given millions of dollars in economic aid to Sri Lanka.",
  },
  {
    id: 37,
    text: "Student",
    response: "Student life is filled with learning opportunities.",
  },
  {
    id: 38,
    text: "Nature",
    response: "Gravity is one of the basic laws of nature.",
  },
  {
    id: 39,
    text: "Hunger",
    response: "We must come together to fight against world hunger.",
  },
  {
    id: 40,
    text: "Calendar",
    response: "First calendar was made in Mesopotamia.",
  },
  {
    id: 41,
    text: "Witness",
    response: "Many countries have witnessed inflation due to covid.",
  },
  {
    id: 42,
    text: "Tough",
    response: "Tough time teaches valuable lessons.",
  },
  {
    id: 43,
    text: "Rejection",
    response: "Learn to face rejection.",
  },
  {
    id: 44,
    text: "Poor",
    response: "Donate to poor and needy people.",
  },
  {
    id: 45,
    text: "Shy",
    response: "We must not shy away from challenges.",
  },
  {
    id: 46,
    text: "Action",
    response: "Certain situations demand immediate action.",
  },
  {
    id: 47,
    text: "Society",
    response: "Poverty hurts society as whole.",
  },
  {
    id: 48,
    text: "Warn",
    response: "Falling prices may be a warning sign of recession.",
  },
  {
    id: 49,
    text: "Occupation",
    response:
      "Evidence of past human occupations were found from cave paintings.",
  },
  {
    id: 50,
    text: "Image",
    response: "Plane mirror image is laterally inverted.",
  },
  {
    id: 51,
    text: "Pace",
    response: "Cities have fast pace of life.",
  },
  {
    id: 52,
    text: "Security",
    response: "Soldiers ensure National security.",
  },
  {
    id: 53,
    text: "Shortage",
    response: "Reduce food wastage to prevent its shortage.",
  },
  {
    id: 54,
    text: "Dark",
    response: "Dark side of moon is never visible from earth.",
  },
  {
    id: 55,
    text: "Chase",
    response: "Chase your dream and follow your passion.",
  },
  {
    id: 56,
    text: "Official",
    response: "CEO is the official head of the company.",
  },
  {
    id: 57,
    text: "Industry",
    response: "The tech industry is revolutionizing the country.",
  },
  {
    id: 58,
    text: "Movement",
    response: "The Constitution guarantees freedom of movement.",
  },
  {
    id: 59,
    text: "Fall",
    response: "Darkness falls early in the winter.",
  },
  {
    id: 60,
    text: "Temper",
    response: "One must learn to control their temper.",
  },
  {
    id: 60,
    text: "Temper",
    response: "One must learn to control their temper.",
  },
];
